import { format, parseISO } from 'libs/dates'

export const formatPayoutDate = (value: string) => format(parseISO(value), 'MMM d, yyyy, hh:mm aaa')
